function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M11,0L4,5.9099998H0v6h4L11,18V0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M12.9999905,8.9100704c-0.0019197,0.5548801-0.1576929,1.0983496-0.4499998,1.5699997l0.5599995,0.9300003 c0.6178999-0.7701702,0.9291096-1.7416706,0.8737297-2.7275105c-0.0553904-0.9858499-0.4734497-1.916379-1.1737289-2.6124916 L12.2399902,6.910069C12.7305193,7.46067,13.00107,8.1726503,12.9999905,8.9100704z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M16.0000801,8.9101c-0.0024099-0.8681993-0.1932106-1.7255402-0.5592299-2.5128202 c-0.3660097-0.7872796-0.89853-1.4857469-1.5607719-2.0471816l-0.5500002,0.860002 C13.825552,5.6503401,14.22756,6.1856098,14.51227,6.7841597C14.7969799,7.3827,14.95858,8.03232,14.9874897,8.6945 c0.0289202,0.6621704-0.0754499,1.32341-0.3069096,1.9444904c-0.2314501,0.6210794-0.5852804,1.1893501-1.0405006,1.6711092 l0.5400009,0.8900003c0.5741396-0.5575495,1.0309391-1.2243299,1.3435097-1.9610901 C15.8361502,10.5022507,15.9981594,9.7104101,16.0000801,8.9101z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M16.9999695,8.9099007c-0.0011692,0.973629-0.2054291,1.9363089-0.5997391,2.826519 c-0.39431,0.8901806-0.9700003,1.6883802-1.6902599,2.3434801l0.5199995,0.8699999 c0.8886099-0.7674999,1.5973692-1.7212,2.0759897-2.7933998c0.4786205-1.0721703,0.7153606-2.2365704,0.6933994-3.4105301 C17.9774094,7.572,17.6973095,6.4172702,17.1789398,5.3637199s-1.26229-1.9800799-2.1789694-2.7138181l-0.5299997,0.8399982 C15.2658901,4.1503201,15.90557,4.9789,16.343029,5.91607C16.7804909,6.85323,17.0048504,7.87568,16.9999695,8.9099007z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.0007591px",
    height: "18px",
    viewBox: "0 0 18.0007591 18",
    style: {
      "enableBackground": "new 0 0 18.0007591 18"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/audio-enabled.5a95dd1d.svg";
export { SvgComponent as ReactComponent };